export type VendorOfferSuccessPage = {
  /** `vendor_offer_tokens.token`. Soho’s public path is `/soho`; the token is `sohohouse`. */
  token: string;
  vendorName: string;
  body: string;
};

export const VENDOR_OFFER_SUCCESS_PAGES: Record<string, VendorOfferSuccessPage> = {
  'the-club': {
    token: 'the-club',
    vendorName: 'The Club',
    body: 'Your Heal Subscription is active. Download Heal and sign in with the same email you used to pay.',
  },
  soho: {
    token: 'sohohouse',
    vendorName: 'Soho House',
    body: 'Your Heal Subscription is active. Download Heal and sign in with the same email you used to pay.',
  },
  spacemade: {
    token: 'spacemade',
    vendorName: 'Spacemade',
    body: 'Your Heal Subscription is active. Download Heal and sign in with the same email you used to pay.',
  },
};
